import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import type { TypeParams } from './types'

@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context => rxjs.of(context ?? []),
  )

  /**
   * Retrieves the attributes for the entity model.
   */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('name', {
        isSortable: true,
        name: 'Name',
      }),
      ec.models.Attribute.fromKey<TypeParams>('description', {
        isSortable: true,
        name: 'Description',
      }),
    ])
}
